import { initialState } from '../state';
import { BpmnXmlActions, BpmnXmlActionTypes } from '../actions';

export function bpmnXml(state = initialState.bpmnXml, action: BpmnXmlActions): string {
  switch (action.type) {
    case BpmnXmlActionTypes.UPDATE_BPMN_XML: {
      return  action.payload.bpmnXml;
    }
    default: {
      return state;
    }
  }
}
